import { getMutations } from 'entities/_config';

import { apiCall, SuccessData } from 'services/api';

export const authMutations = getMutations({
  logout: {
    action: async (): Promise<SuccessData> => {
      return apiCall({
        path: '/auth/logout',
        withCookies: true,
      });
    },

    messages: {
      suppressSuccess: true,
    },
  },

  /**
   * Use this if the user is trapped in a redirect
   * loop between the apps. This could happen if he
   * clears the LS externally, but not the domain cookies
   */
  purgeSession: {
    action: async (): Promise<SuccessData> => {
      return apiCall({
        path: '/auth/clear',
        withCookies: true,
        auth: false,
      });
    },

    messages: {
      suppressSuccess: true,
      suppressError: true,
    },
  },

  forgotPassword: {
    action: async (payload: { email: string }): Promise<SuccessData> => {
      return apiCall({
        path: '/auth/password/forgot',
        auth: false,
        payload,
      });
    },

    messages: {
      suppressSuccess: true,
      suppressError: true,
    },
  },

  resetPasswordByCode: {
    action: async (payload: {
      email: string;
      code: string;
      password: string;
      confirmPassword: string;
    }): Promise<SuccessData> => {
      return apiCall({
        path: '/auth/password/recover/code',
        auth: false,
        payload,
      });
    },

    messages: {
      suppressSuccess: true,
      suppressError: true,
    },
  },

  resetPasswordByToken: {
    action: async (payload: {
      token: string;
      password: string;
      confirmPassword: string;
    }): Promise<SuccessData & { email: string }> => {
      return apiCall({
        path: '/auth/password/recover',
        auth: false,
        payload,
      });
    },

    messages: {
      suppressSuccess: true,
      suppressError: true,
    },
  },
});
